<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar title="在线讣告" left-arrow fixed :z-index="99" @click-left="onClickLeft" :border="false">
      <template #right>
        <van-icon name="share" @click="shareHandler"/> 
      </template>
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="obit-banner">
      <img src="@/assets/images/obit_bg.jpg" class="obit_bg">
      <div class="box">
        <van-image
          width="90"
          height="116"
          radius="3"
          fit="cover"
          :src="data.PhotoPath"
        />
        <h2 class="title">{{data.Title}}</h2>
        <router-link :to="{path:'/MemorialHall?id='+ memorialHallSerialNumber}" class="goBtn">进入纪念馆</router-link>
      </div>
    </div>
    
    <div class="obit-details">
      {{data.Content}}
    </div>
  </div>
</template>

<script>
  import soshm from 'soshm';
  import { Toast } from 'vant'
  export default {
    data() {
      return {
        memorialHallSerialNumber: "",
        data: [],
      };
    },
    components: {
    },
    created(){
      this.getObituaryDetail();
    },
    methods :{
      onClickLeft() {
        this.$back();
        // this.$router.go(-1)
      },
      /**推荐给朋友**/
      shareHandler(){
        // soshm.popIn({
        //   title: '弹窗分享',
        //   sites: ['weixin', 'weixintimeline', 'weibo', 'qzone', 'tqq', 'qq']
        // });
          if(this.$weixin.IsWeiXin()){
            soshm.weixinSharetip();
          }else{
            Toast('当前暂不支持分享');
          }
      },
      getObituaryDetail(){
        var that = this;
        var id = this.$route.query.id;
        // console.log(id);
        var _this = this;
        this.$store
          .dispatch({
            type: "GetObituaryDetail",
            id: id,
          })
          .then(result => {
            // console.log(result);
            _this.data = result.ObituaryExtend;
            _this.memorialHallSerialNumber = result.ObituaryExtend.MemorialHallSerialNumber;
            if(that.$weixin.IsWeiXin()){
              that.initweixinShare();
            }
          });
        },
        initweixinShare(){
           var that = this;
            this.$nextTick(() => {
              that.$weixin.ShareWeiXinAppMessage(
                that.data.Title,
                that.data.Content,
                that.data.PhotoPath,
                'MemorialHall?id=' + that.memorialHallSerialNumber
              );
            })
          
        }
    }
  };
</script>

<style scoped>
.obit-banner{
  width: 100%;
  height: 220px;
  position: relative;
}
.obit-banner .obit_bg{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.obit-banner>.box{
  position: relative;
  width: 100%;
  height: 100%;
  padding: 15px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.obit-banner>.box>.title{
  font-size: 17px;
  text-align: center;
  color: #333;
  margin-top: 4px;
  font-weight: normal;
}
.obit-banner>.box>.goBtn{
  height: 28px;
  line-height: 28px;
  padding: 0 10px;
  font-size: 13px;
  color: #fff;
  background-color: rgba(0,0,0,0.45);
  margin-top: 10px;
}
.obit-details{
  padding: 24px 30px;
  font-size: 14px;
  color: #333;
  line-height: 1.6;
}
</style>
